import React from "react";

/**
 * A segmented control — one bordered group, options butted together.
 *
 * Real <button>s rather than styled divs, so the whole control is reachable
 * and operable from the keyboard for free. `aria-pressed` (not `aria-checked`)
 * because these are toggles within a group, not a radio set with a hidden
 * input behind them.
 */
export default function SegControl({ options, value, onChange, label }) {
  return (
    <div className="seg" role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={String(o.value)}
          type="button"
          className={o.value === value ? "selected" : undefined}
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
